import { render, staticRenderFns } from "./MyMind.vue?vue&type=template&id=ab1ae080"
import script from "./MyMind.vue?vue&type=script&lang=js"
export * from "./MyMind.vue?vue&type=script&lang=js"
import style0 from "./MyMind.vue?vue&type=style&index=0&id=ab1ae080&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports